"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prism_1 = require("react-syntax-highlighter/dist/esm/styles/prism");
const styles_1 = require("./styles");
exports.Code = ({ language = "tsx", children }) => {
    return (react_1.default.createElement(styles_1.Container, { language: language, style: prism_1.tomorrow, className: "mb-4 mt-4", showLineNumbers: true, wrapLines: true }, children));
};
